// Authorization
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const NOT_AUTHENTICATED = 'notAuthenticated'

// Languages
export const UPDATE_LANGUAGE = 'updateLanguage'

// Dashboard
export const GET_DASHBOARD_STATS = 'getDashboardStats'

// Chargers
export const GET_CHARGERS = 'getChargers'

// Media
export const GET_DEFAULT_MEDIA = 'getDefaultMedia'
export const GET_MEDIA = 'getMedia'
export const GET_CRITERIA = 'getCriteria'
export const SAVE_DEFAULT_MEDIA = 'saveDefaultMedia'
export const SAVE_MEDIA_NAME = 'saveMediaName'
export const SAVE_MEDIA_DATES = 'saveMediaDates'
export const SAVE_MEDIA = 'saveMedia'
export const LOAD_ACTIVE_MEDIA = 'loadActiveMedia'
export const DELETE_MEDIA = 'deleteMedia'

// Partners
export const GET_PARTNERS = 'getPartners'

// Users
export const GET_USERS = 'getUsers'
export const SAVE_USER = 'saveUser'

// Sky Objects
export const GET_SKY_OBJECTS = 'getSkyObjects'
export const SAVE_SKY_OBJECT = 'saveSkyObject'